import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import AboutSection from './components/AboutSection';
import ArticlesShowcase from './components/ArticlesShowcase';
import ArticleCTA from './components/ArticleCTA';
import CTASection from './components/CTASection';
import Footer from './components/Footer';

const websiteJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: 'Sugargoo Spreadsheet',
  url: 'https://sugargoosheet.hair',
  description: 'The ultimate Sugargoo Spreadsheet 2026 — product research database, shopping guides, and expert tips for smarter Sugargoo shopping.',
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: 'https://sugargoosheet.hair/article/{search_term_string}',
    },
    'query-input': 'required name=search_term_string',
  },
};

const orgJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: 'Sugargoo Spreadsheet',
  url: 'https://sugargoosheet.hair',
  logo: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/1fc56da0b352904925ac780066826afe.jpeg',
};

export default function Home() {
  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <Navbar />
      <main>
        <Hero />
        <CategoryDropdown />
        <CategoryGrid />
        <AboutSection />
        <ArticlesShowcase />
        <ArticleCTA />
        <CTASection />
      </main>
      <Footer />
    </>
  );
}